@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Automação de Mensagens</div>
        </div>
        <div class="d-flex flex-wrap flex-grow-1 justify-content-end">
          <a class="btn btn-secondary btn_titulo" routerLink="/automacao-mensagens-cadastro">Nova Mensagem</a>
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4">
      <div class="table-responsive">
        <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th></th>
                <th class="tabela_borda"></th>
                <th class="tabela_borda text-center">Tipo</th>
                <th class="tabela_borda">Mensagem</th>
              </tr>
            </thead>
            <tbody>
              <tr *cdkVirtualFor="let automacaoEventoMensagem of automacaoEventosMensagens; templateCacheSize: 0;">
                <td class="text-center tabela_acao">
                  <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarMensagem(automacaoEventoMensagem.id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Excluir" (click)="deletarMensagem(automacaoEventoMensagem.id)"></i>
                </td>
                <td class="text-center tabela_borda">{{ automacaoEventoMensagem.nome_tipo }}</td>
                <td class="tabela_borda">{{ automacaoEventoMensagem.mensagem }}</td>
              </tr>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
}
